import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBroom } from "@fortawesome/free-solid-svg-icons";
import { HTTP_CLIENT } from "../../hooks";
import { ConfirmationModal } from "../ConfirmationModal";

interface Props {
  jwt: string;
}

export function Maintenance({ jwt }: Readonly<Props>) {
  const [showPruneConfirmModal, setShowPruneConfirmModal] = useState(false);
  const [pruning, setPruning] = useState(false);

  const runPruneJob = async () => {
    setShowPruneConfirmModal(false);
    setPruning(true);
    try {
      await HTTP_CLIENT.post({
        path: "/api/v2/maintenance/prune",
        headers: { Authorization: `Bearer ${jwt}` },
      });
      toast.success("Prune job completed successfully");
    } catch (e: any) {
      console.error(e.stack);
      if (e.status === 401) {
        toast.error("Your session has expired. Please log in again.");
      } else if (e.status === 403) {
        toast.error("Administrator role required to run the prune job.");
      } else {
        toast.error("Prune job failed. See console for details.");
      }
    } finally {
      setPruning(false);
    }
  };

  return (
    <>
      <Row>
        <Col>
          <h1>Maintenance</h1>
        </Col>
      </Row>

      <Row>
        <Col md={8} lg={6}>
          <Button
            variant="danger"
            disabled={pruning}
            onClick={() => setShowPruneConfirmModal(true)}
          >
            <FontAwesomeIcon icon={faBroom} className="me-2" />
            {pruning ? "Pruning..." : "Execute Manual Prune"}
          </Button>
        </Col>
      </Row>

      <ConfirmationModal
        show={showPruneConfirmModal}
        onHide={() => setShowPruneConfirmModal(false)}
        text={
          <>
            permanently prune outdated channels, unmapped releases, and unused
            binaries from the update server. This cannot be undone. Continue?
          </>
        }
        onConfirm={runPruneJob}
        confirmationButtonText={"Continue"}
      />
    </>
  );
}
